// extracted by mini-css-extract-plugin
export default {"companySign":"CompanySign_companySign__OZEuR"};